import i18next from 'i18next';
import { PromoCodeTypes } from "enums";

export const promoCodelabelsByType = (): Record<PromoCodeTypes, string> => ({
    [PromoCodeTypes.freeDelivery]: i18next.t('promo-code-type.free-delivery'),
    [PromoCodeTypes.percent]: i18next.t('promo-code-type.percent'),
    [PromoCodeTypes.value]: i18next.t('promo-code-type.value'),
});
